import { render, staticRenderFns } from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=template&id=336e21c6&scoped=true&"
import script from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectBreadcrumbsComponent.vue?vue&type=style&index=0&id=336e21c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336e21c6",
  null
  
)

export default component.exports